import React from "react";
import useReveal from "../hooks/useReveal";
import { useContent } from "../context/ContentContext";

export default function Pricing() {
  const [ref, inView] = useReveal();
  const { content } = useContent();
  const pricing = content.pricing;
  const servicesUrl = content.settings.servicesUrl;

  return (
    <section id="pricing" className="bg-[#F7F2EA] py-24 md:py-32 px-6">
      <div ref={ref} className={`max-w-5xl mx-auto reveal ${inView ? "in-view" : ""}`}>
        <div className="flex items-center gap-4 mb-3">
          <span className="text-xs tracking-[0.25em] text-[#C6A15B] uppercase">/ 03</span>
          <span className="gold-divider" />
          <span className="text-xs tracking-[0.25em] text-[#8A857A] uppercase">
            Best Skincare Experience
          </span>
        </div>

        <h2 className="font-serif-display text-4xl md:text-6xl text-[#1A1A1A] mb-4">Pricing</h2>
        <p className="text-[#4A463F] font-light max-w-2xl mb-14 leading-relaxed">
          A variety of rejuvenating treatments designed to enhance beauty and wellness in a serene
          environment. Consultations are complimentary.
        </p>

        <div className="divide-y divide-[#E4DBCB] border-t border-b border-[#E4DBCB]">
          {pricing.map((p) => (
            <div key={p.id || p.name} className="flex items-baseline justify-between gap-4 py-5 group">
              <span className="font-serif-display text-xl md:text-2xl text-[#1A1A1A] group-hover:text-[#C6A15B] transition-colors">
                {p.name}
              </span>
              <span className="flex-1 mx-4 border-b border-dotted border-[#CDbfa8] translate-y-[-4px] hidden sm:block" />
              <span className="text-right whitespace-nowrap">
                <span className="text-lg md:text-xl text-[#1A1A1A]">{p.price}</span>
                <span className="block text-[11px] tracking-[0.12em] uppercase text-[#8A857A]">
                  {p.unit}
                </span>
              </span>
            </div>
          ))}
        </div>

        <div className="mt-12">
          <a
            href={servicesUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-[#0C0C0C] text-[#C6A15B] text-xs tracking-[0.2em] uppercase px-9 py-4 hover:bg-[#1a1a1a] transition-colors"
          >
            View Full Price List
          </a>
        </div>
      </div>
    </section>
  );
}
